import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PostProspectResponse } from '../../Models/Models/Customer/PostProspectResponse';
import { Prospect } from '../../Models/Models/Customer/Prospect';

declare var IS_RUNNING_IN_APP_POOL;

export class ProspectClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(prospect: Prospect): Promise<PostProspectResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Prospect/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { prospect: prospect }

    return AjaxWrapper.post<PostProspectResponse, any>(url, data);
  }
}

